import { gql } from '$lib/apollo';
import { TESTIMONIAL_FIELDS } from '../queries';

export const EDIT_TESTIMONIAL = gql`
  mutation EditTestimonial($input: TestimonialEditInput!) {
    testimonialEdit(input: $input) {
      result {
        ...TestimonialFields
        featuredPosition
      }
      errors {
        ... on Error {
          code
          message
        }
      }
    }
  }
  ${TESTIMONIAL_FIELDS}
`;
